export default {
  meta: {
    title: '复盘设置'
  }
};
